import NextLink from 'next/link'
import { type FC } from 'react'

import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { Link, Rating, Skeleton } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { TosSuperscriptHowProductRatingCalculated } from '../../../tos-superscripts'
import { urlGetRelativeUrl } from '../../../url-handling'
import { crossSellAccessorGetLocalizedProductDeepLink } from '../../model/crossSellAccessorGetLocalizedProductDeepLink'

type CrossSellHorizontalSliderItemCompactRatingProps = {
  product?: CrossSellProduct
}

export const CrossSellHorizontalSliderItemCompactRating: FC<
  CrossSellHorizontalSliderItemCompactRatingProps
> = ({ product }) => {
  const { language, tenant } = useGlobalConfigContext()

  if (!product) {
    return (
      <div className="mb-1 flex w-full flex-col items-center text-xs">
        <Skeleton className="w-20" />
        <Skeleton className="mt-2 w-10" />
      </div>
    )
  }

  const rating = product.bewertung_durchschnitt
    ? Math.round(Number(product.bewertung_durchschnitt))
    : 0

  if (rating === 0) {
    return <div className="flex h-9 w-full" />
  }

  const href = `${urlGetRelativeUrl(
    crossSellAccessorGetLocalizedProductDeepLink({
      language,
      product,
      tenant,
    }),
  )}#user-reviews-section`

  return (
    <div className="flex w-full flex-col flex-wrap items-center text-xs">
      <span className="flex leading-none">
        <Link<typeof NextLink>
          className="flex"
          data-qa-id="product-rating"
          href={href}
          slots={{ root: NextLink }}
        >
          <Rating
            className="text-l"
            readOnly
            slotProps={{
              iconContainer: {
                className: '-mx-0.5',
              },
            }}
            value={rating}
          />
        </Link>
        <TosSuperscriptHowProductRatingCalculated className="top-1 ml-1" />
      </span>
      <Link<typeof NextLink>
        className="no-underline"
        color="inherit"
        data-qa-id="product-rating"
        href={href}
        slots={{ root: NextLink }}
      >{`(${product.bewertung_anzahl})`}</Link>
    </div>
  )
}
